import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@org/ui';
import { AnalyticsPage } from '../app/components/analytics/analytics-page';
import { parseSearch, type AnalyticsSearch } from '../app/components/analytics/filters';

export const Route = createFileRoute('/analytics')({
  component: AnalyticsRoute,
  validateSearch: (search: Record<string, unknown>): AnalyticsSearch => parseSearch(search),
});

const ANALYTICS_PERMISSIONS = ['admin:all', 'analytics:read'];

function AnalyticsRoute() {
  return (
    <ProtectedRoute requiredPermissions={ANALYTICS_PERMISSIONS}>
      <AnalyticsPage />
    </ProtectedRoute>
  );
}
